declare var BX: any;

class ContactUs {
  form: HTMLFormElement | null = null;
  requiredInputs: HTMLInputElement[] = [];

  constructor() {
    this.form = document.querySelector('.contact-us__form');
    this.requiredInputs = Array.from(this.form?.querySelectorAll('.contact-us__required-input') || []);




    if(!BX) return;

    if (!this.form) return;


    BX.ready(() => {

      if (!this.form) return;
      this.form.addEventListener('submit', (e: Event) => {
        this.handleSubmit(e);
      });
    });
  }

  checkRequiredInputs() {
    const captchaInput = document.querySelector('input[name="smart-token"]') as HTMLInputElement;
    if(captchaInput) {
      this.requiredInputs.push(captchaInput);
    }
    let isValid = true;
    this.requiredInputs.forEach(input => {
      if(input.type === 'checkbox') {
        if(!input.checked) {
          input.classList.add('input--error');
          isValid = false;
        } else {
          input.classList.remove('input--error');
        }
      } else if(input.type !== 'hidden') {
        if(!input.value) {
          input.classList.add('input--error');
          isValid = false;
        } else {
          input.classList.remove('input--error');
        }
      } else if(input.type === 'hidden') {
        if(!input.value) {
          const captchaErrorText = this.form?.dataset.captchaErrorText;
          window.notifications.addNotification('', captchaErrorText || 'Ошибка проверки captcha', 'error');
          isValid = false;
        }
      }
    });
    return isValid;
  }

  private resetForm() {
    if (!this.form) return;
    this.form.reset();
  }

  handleSubmit(e: Event) {
    e.preventDefault();
    const $this = this;
    if (!this.form) return;
    if(!this.checkRequiredInputs()) return;

    let request = BX.ajax.runComponentAction('airelations:feedback.form', 'sendForm', {
      mode: 'class',
      data: new FormData(this.form),
    });

    request.then(function (response: {"status":"success" | "error","data":{"data":string,"status":"success" | "error" },"errors":[]}) {
      if(response.data.status === 'success') {
        const successTitle = $this.form?.dataset.successTitle;
        window.notifications.addNotification(successTitle || 'Спасибо!', response.data.data, 'success');
        $this.resetForm();
      } else {
        const errorTitle = $this.form?.dataset.errorTitle;
        window.notifications.addNotification(errorTitle || "Ошибка!", response.data.data, 'error');
      }
    }, function (response: any) {
      const errorTitle = $this.form?.dataset.networkErrorTitle;
      window.notifications.addNotification(errorTitle || "Ошибка связи", 'Попробуйте еще раз позже', 'error');
    });
  }

}

export default function contactUs() {
  return new ContactUs();
}